import {
  CustomFieldResourceType,
  customFieldResourceTypeLabels,
} from "@repo/app-types/entities/customField";
import {
  getMultiSelectOptionLabel,
  type MultiSelectSection,
} from "@repo/ui/Select/multiSelect";
import { useMemo } from "react";
import { useAllUserCustomFieldDefinitionsQuery } from "../api/entities/userCustomField.js";

// TODO: Make this reusable for single select fields.
export function useCustomFieldDefinitionSelectOptions(): MultiSelectSection[] {
  const { data: customFieldDefinitions } =
    useAllUserCustomFieldDefinitionsQuery();

  const options = useMemo(() => {
    // TODO: Better loading state.
    if (!customFieldDefinitions) {
      return [];
    }

    const sections: MultiSelectSection[] = [];

    // TODO: Allow this to be configurable by the caller (without breaking memoization).
    for (const resourceType of [
      CustomFieldResourceType.CONTACT,
      CustomFieldResourceType.ACCOUNT,
      CustomFieldResourceType.GRADING,
    ]) {
      const fieldsForType = customFieldDefinitions.filter(
        (def) => def.resource_type === resourceType,
      );

      if (fieldsForType.length > 0) {
        sections.push({
          id: resourceType,
          label: customFieldResourceTypeLabels[resourceType] + " custom fields",
          options: fieldsForType.map((def) => ({
            id: def.id,
            label: def.display_name,
          })),
        });
      }
    }

    return sections;
  }, [customFieldDefinitions]);

  return options;
}

export function useCustomFieldDefinitionSelectLabel(
  options: MultiSelectSection[],
  selectedCustomFieldDefinitionId: string | undefined,
) {
  return useMemo(() => {
    if (!options || !selectedCustomFieldDefinitionId) {
      return undefined;
    }

    return (
      getMultiSelectOptionLabel(options, selectedCustomFieldDefinitionId) ??
      "Unknown"
    );
  }, [options, selectedCustomFieldDefinitionId]);
}

export function useCustomFieldDefinitionSelectProps(
  selectedCustomFieldDefinitionId: string | undefined,
) {
  const options = useCustomFieldDefinitionSelectOptions();

  const label = useCustomFieldDefinitionSelectLabel(
    options,
    selectedCustomFieldDefinitionId,
  );

  return { customFieldLabel: label, customFieldOptions: options };
}
